import React from "react";
import Filter from "../FilterSelect/FilterSelect";
import { Accordion } from '@patternfly/react-core';
import Utils from "../utils/Customizations";


interface IFilterProps {
  productsSelectedItemsArray: string[];
  contentTypesSelectedItemsArray: string[];
  topicsSelectedItemsArray: string[];
  productOptions: string[];
  contentTypeOptions: string[];
  topicOptions: string[];
  onProductUpdate: (newSelectedOptions: string[], product: string) => any;
  onContentTypeUpdate: (newSelectedOptions: string[], contentType: string) => any;
  onUpdateVersions?: (versionsSelected: string[], currProduct: string, allVersions: string[], selection?: string) => any;
  onTopicUpdate: (newSelectedOptions: string[], topic: string) => any;
  activeProductVersions: any[]
  activeContentTypeFilter: string[]
  productVersions: any[]
  productKeyProp: string
  contentTypeKeyProp: string
  topicKeyProp: string
  isDisabled: boolean
  isMobile: boolean
  isFacetABTest: boolean
}


export default function Filters(props: IFilterProps) {


  return (
    <Accordion asDefinitionList isBordered>
          <div className="products-filter-container">
              <Filter
                heading={"Products"}
                selectedItemsArray={props.productsSelectedItemsArray}
                options={props.productOptions}
                onUpdate={props.onProductUpdate}
                onUpdateVersions={props.onUpdateVersions}
                additionalInfoPopover={undefined}
                disableCollapse={undefined}
                toggleText={"Products"}
                productVersions={props.productVersions}
                activeProductVersions={props.activeProductVersions}
                contentTypes={props.activeContentTypeFilter}
                keyProp={props.productKeyProp}
                //ternary here if env is ___ then not disabled, otherwise it is disabled 
                isDisabled={props.isDisabled}
                isMobile={props.isMobile}
                isFacetABTest={props.isFacetABTest}
              />
            </div>
            <div className="content-type-filter-container">
              <Filter
                heading={"Content Type"}
                selectedItemsArray={props.contentTypesSelectedItemsArray}
                options={props.contentTypeOptions}
                onUpdate={props.onContentTypeUpdate}
                additionalInfoPopover={undefined}
                disableCollapse={true}
                toggleText={"Content type"}
                productVersions={[]}
                activeProductVersions={[]}
                contentTypes={[]}
                keyProp={props.contentTypeKeyProp}
                isDisabled={props.isDisabled}
                isMobile={props.isMobile}
                isFacetABTest={props.isFacetABTest}
              />
            </div>
            {Utils.getHostUrl() === "developers.redhat.com" && <div className="topic-filter-container">
              <Filter
                heading={"Topics"}
                selectedItemsArray={props.topicsSelectedItemsArray}
                options={props.topicOptions}
                onUpdate={props.onTopicUpdate}
                additionalInfoPopover={undefined}
                disableCollapse={true}
                toggleText={"Topics"}
                productVersions={[]}
                activeProductVersions={[]}
                contentTypes={[]}
                keyProp={props.topicKeyProp}
                isDisabled={props.isDisabled}
                isMobile={props.isMobile}
                isFacetABTest={props.isFacetABTest}
              />
            </div>}
      </Accordion>

  );
}
